import { WaitTask } from './waitTask.types'

export const createWaitTask = ({
  name,
  taskReferenceName,
  inputParameters
}: Omit<WaitTask, 'type'>): WaitTask => {
  return {
    type: 'WAIT',
    name,
    taskReferenceName,
    inputParameters
  }
}
